import {connect} from "react-redux";
import {AppState} from "../../RootReducer";
import {Dispatch} from "redux";
import React from "react";
import {initWithdraw} from "../../payments/WithdrawActions";
import Title from "../../layout/Title";
import {CurrencyDefinition, WithdrawContext} from "../../http/protocol";

import {t} from "../../i18n";
import {BrandA} from "../buttons/buttons";


interface Props  {
    updateAddress? : (recipientAddress : string) => void,
    initWithdraw? : ()=>void;
    amount?: string;
    currency?: string;
    confirmedStatus?:boolean;
    currencies?: Array<CurrencyDefinition>;
    withdrawContext?: WithdrawContext;

}

interface State {
    withdrawalConfirmed : boolean
}

export class ACHConfirmWithdraw extends React.Component<Props,State> {
    constructor(props : Props) {
        super(props);

        this.state = {withdrawalConfirmed : false};
    }

    getCurrencyName() {
        let currencyName = this.props.currencies && this.props.currencies.filter((currencyDef: CurrencyDefinition) => {
            if(this.props && this.props.currency && currencyDef.code == this.props.currency) {
                return currencyDef.name;
            }
        });
        if(currencyName &&currencyName.length > 0) {
            return currencyName[0].name;
        } else {
            return this.props.currency;
        }
    }

    render() {
        if(!this.props.withdrawContext) {
            return <div></div>
        } else {
            return (
                <div>
                    <div className="withdraw-title">
                        <Title animate={true} title={t("withdraw.ach.title")}/>
                    </div>
                    <div className="withdraw-summary">
                        <div className="withdraw-summary-text">
                            <p>{t("withdraw.ach.bank-name")}:</p>
                            <p>{this.props.withdrawContext.bankTransferContext?.bankName}</p>
                        </div>
                        <div className="withdraw-summary-text">
                            <p>{t("withdraw.ach.routing-number")}:</p>
                            <p>{this.props.withdrawContext.bankTransferContext?.bankRoutingNumber}</p>
                        </div>
                        <div className="withdraw-summary-text">
                            <p>{t("withdraw.ach.account-number")}:</p>
                            <p>{this.props.withdrawContext.bankTransferContext?.bankAccountNumber}</p>
                        </div>

                        <div className="withdraw-summary-text">
                            <p>{t("withdraw.ach.amount")}:</p>
                            <p>{this.props.amount} {this.getCurrencyName()}</p>
                        </div>
                        <div className="withdraw-confirm">

                        </div>
                    </div>

                    <BrandA className={"btn btn-cta full-width large"} onClick={()=>this.props.initWithdraw?.()}>
                        {t("withdraw.ach.continue")}
                    </BrandA>

                </div>
            )
        }
    }
}
const mapStateToProps = (app : AppState)=> {
    return {
        currency : app.payments.withdraw.activeCurrency,
        amount : app.payments.withdraw.amount,
        currencies: app.user.user != undefined ? app.user.user.currencies : undefined,
        withdrawContext : app.payments.withdraw.withdrawContext
    }
};
const mapDispatchToProps = (dispatch: Dispatch)=> ({
    initWithdraw : () => dispatch(initWithdraw() as any)

});

export default connect(mapStateToProps,mapDispatchToProps)(ACHConfirmWithdraw as any);